import type {ElementoDelLote, ResultadoDelLote} from '@cnc/contracts';

// Cambios de una carga del Status que se aceptan, uno por uno (Daniel,
// 7/10/2026): codigo de la exportacion → campos marcados.
export type CambiosAceptados = Map<string, Set<string>>;

// Una exportacion nueva sin campos se acepta con esta marca (solo crearla).
export const CREAR = '(crear)';

// Lo que se puede aceptar de cada exportacion.
export const camposDe = (x: ElementoDelLote): string[] =>
  x.errores.length ? [] : x.cambios.length ? x.cambios.map(c => c.campo) : x.resultado === 'nueva' ? [CREAR] : [];

// Todos los cambios de la vista previa, para "Aceptar todo".
export const todosLosCambios = (resultado: ResultadoDelLote): CambiosAceptados =>
  new Map(resultado.elementos.filter(x => camposDe(x).length).map(x => [x.codigo, new Set(camposDe(x))]));

export const cuantosCambios = (aceptados: CambiosAceptados) =>
  [...aceptados.values()].reduce((total, campos) => total + campos.size, 0);
